<nav class="bciti-menu" [class.is-collapsed]="!menuOpen">
    <header>
        <button 
            class="menu-toggler"
            [class.is-active]="menuOpen" 
            (click)="toggleMenu($event)">
            <span class="icon-arrow-right"></span>
        </button>
        
        <img class="user-avatar" *ngIf="(picture$ | async) as picture; else noPhoto" [src]="picture" alt="demo-avatar">
        <ng-template #noPhoto>
            <img class="user-avatar" src="assets/images/default-avatar.png" alt="demo-avatar">
        </ng-template>
        <p class="user-name-menu" [class.is-hidden]="!menuOpen">
            {{name$ | async}}
        </p>
    </header>

    <mat-list *ngIf="(mainItems$ | async) as mainItems">
        <mat-list-item 
            *ngFor="let mainItem of mainItems"
            class="menu-list-style" 
            [routerLink]="[mainItem.path]" 
            [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: mainItem.path === '/' ? true : false }">
            <a class="menu-list-link">
                <span class="{{mainItem.icon}} menu-icon"></span>
                <span class="menu-list-link-text" [class.is-hidden]="!menuOpen">{{mainItem.text}}</span>
            </a>
        </mat-list-item>
    </mat-list>

    <mat-divider></mat-divider>

    <mat-list *ngIf="(secItems$ | async) as secItems">
        <mat-list-item 
            *ngFor="let secItem of secItems"
            class="menu-list-style" 
            [routerLink]="[secItem.path]" 
            [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: secItem.path === '/' }">
            <a class="menu-list-link">
                <span class="{{secItem.icon}} menu-icon"></span>
                <span class="menu-list-link-text" [class.is-hidden]="!menuOpen">{{secItem.text}}</span>
            </a>
        </mat-list-item>
    </mat-list>

    <div class="menu-bottom">
        <div class="language-toggle">
            <span *ngFor="let language of availableLanguages$ | async">
                <button class="bciti-link" *ngIf="(language$ | async) !== language" (click)="selectLanguage(language)">{{ language }}</button>
            </span>
        </div>

        <div class="report-issue">
            <button (click)="openReportProblemDialog()" class="bciti-button bciti-button--blue-inversed report-button" [class.button-no-border]="!menuOpen">
                <span [class]="Icon.WARNING"></span> 
                <span [class.report-issue-text]="!menuOpen">  {{ 'components.menu.report-a-problem' | translate }}</span> 
            </button>
        </div>
    </div>
</nav>
